// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1eHaP","paramInput":"JobSimulator_paramInput__Q0sYd","input":"JobSimulator_input__RSxi8"};